import { ActionsObservable, combineEpics } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, exhaustMap, mergeMap, startWith } from 'rxjs/operators';
import axios from '../../axios-pod';
import actionTypes from '../../utilities/actionTypes';
import {
  fetchFeedsPending,
  fetchFeedsSuccess,
  IFetchFeeds
} from '../actions/feedActions';

export const onLoadFeeds = (action$: ActionsObservable<IFetchFeeds>) =>
  action$.ofType(actionTypes.FETCH_FEEDS).pipe(
    exhaustMap(() => {
      return from(axios.get('/feeds')).pipe(
        mergeMap(response => {
          const result: any[] = [fetchFeedsSuccess(response.data.result)];
          return result;
        }),
        startWith(fetchFeedsPending()),
        catchError(_ => of())
      );
    })
  );

export default combineEpics(onLoadFeeds);
